import { createContext, useContext, useMemo } from "react";
import { AppContext } from "../AppContext";
import { useSocket } from "./useSocket";
import { notificationContextFromSidebar } from "./notificationContext";

const SocketContext = createContext(null);

export const SocketProvider = ({ children }) => {
  // COMY1-398: the bell follows the current role view and the managed
  // community / the supplier's business (from the sidebar data).
  const { sidebarData, userCommunities } = useContext(AppContext);
  const notificationContext = useMemo(
    () => notificationContextFromSidebar(sidebarData),
    [sidebarData],
  );
  const notificationAccess = useMemo(
    () => ({
      communityIds: (userCommunities ?? []).map((community) => community.id),
      canManage: Boolean(
        sidebarData?.isCommunityManager || sidebarData?.isModerator,
      ),
      isSupplier: Boolean(sidebarData?.isSupplier),
    }),
    [
      userCommunities,
      sidebarData?.isCommunityManager,
      sidebarData?.isModerator,
      sidebarData?.isSupplier,
    ],
  );
  const socket = useSocket(notificationContext, notificationAccess);

  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
};

export const useSocketContext = () => {
  const context = useContext(SocketContext);
  if (!context)
    throw new Error("useSocketContext must be used inside a SocketProvider");
  return context;
};
